import { DropdownOptionModel } from './dropdown-option-model';
import { PropertyRequest } from '../shared/models';
import ManufacturedHomePropertyType = PropertyRequest.ManufacturedHomePropertyTypeEnum;

export const MANUFACTURED_HOME_PROPERTY_TYPE_OPTIONS: DropdownOptionModel<ManufacturedHomePropertyType>[] = [
  { value: ManufacturedHomePropertyType.ManufacturedHomeAndLand, display: 'Manufactured Home And Land' },
  { value: ManufacturedHomePropertyType.ManufacturedHomeAndNotLand, display: 'Manufactured Home And Not Land' }
];
